/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useParams } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { useEffect, useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa6";
import LoadAddress from "../create-shipment/loadAddress";
import UnloadAddress from "../create-shipment/UnloadAddress";
import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import { useQuery } from "@tanstack/react-query";
import { getQuote } from "../../lib/quotes";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db, storage } from "../../config/firebase";
import { toast } from "react-toastify";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { DelieveryNote } from "../shared/pdf/deliveryNote";
import { TiDelete } from "react-icons/ti";
import CopyToClipboard from "react-copy-to-clipboard";
import { AmountFormat } from "../../lib/helper/amountFormat";
import CIFValue from "../forms/helperComponent/CIFValue";
import ServiceTemp from "../forms/servicesTemp/temp";
import InsuranceCheckbox from "../forms/helperComponent/insuranceCheckBox";
import CustomButton from "../shared/common/customButton";
import PDFDownloadButton from "../shared/pdf/pdfDownloadBtn";
import DashboardLayout from "../layout";
import { generatePDF } from "../shared/pdf/generatePDF";
import { api } from "../../config/api";
import Loader from "../shared/loader/loader";
import DiscountInput from "../forms/helperComponent/DiscountInput";

function CreateShipment() {
  const { id } = useParams();
  const [pdfLoading, setPdfLoading] = useState(false);
  const allowedFileTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "application/pdf",
    "text/csv",
  ];

  const isFileAllowed = (file) => {
    return allowedFileTypes.includes(file.type);
  };
  const obj = {
    ative: true,
    content: "Book Shipment",
  };
  const [loading, setLoading] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [deliverNow, setDeliverNow] = useState(false);
  const [invalidFields, setInvalidFields] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [templateSelected, setTemplateSelected] = useState(false);
  const [invalidLoadAddressFields, setInvalidLoadAddressFields] = useState([]);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const [invalidUnloadAddressFields, setInvalidUnloadAddressFields] = useState(
    []
  );

  const [Total, setTotal] = useState(0);

  const [totalWeight, setTotalWeight] = useState(0);

  const [subStatusError, setSubStatusError] = useState(false);
  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    postalCode: "",
    houseNo: "",
    place: "",
    country: "",
    air: "",
    cargoValue: { value: "", currency: "USD" },
    cifValue: { value: "", currency: "USD" },
    pcsPackage: [
      {
        weight: { value: "", unit: "Kg" },
        length: { value: "", unit: "cm" },
        width: { value: "", unit: "cm" },
        height: { value: "", unit: "cm" },
      },
    ],
    description: "",
    totalWeight: "",
    deliveryNote: "",
    services: [
      {
        numberOfItem: "",
        description: "",
        exclVAT: "",
      },
    ],
    total: Total,
    insurance: 0,
    subTotal: 0,
    vatPercentage: 0,
    vatAmount: 0,
    currency: "USD",
    orderDetails: {
      eta: "",
      orderDate: "",
      subStatus: "Collection",
    },

    loadAddress_Directory: "",
    loadAddress_ReferenceCustomer: "",
    loadAddress_CompanyName: "",
    loadCountry: "", // Update this to match your actual field name
    loadAddress_ContactName: "", // Update this to match your actual field name
    loadPostalCode: "",
    loadAddress_HouseNumber: "",
    loadAddress_PickUpDate: "",
    loadAddress_PickUpTime: { startTime: "", endTime: "" },
    loadAddress_PhoneNumber: "",
    loadAddress: "",
    loadAddress_IssuedDate: "",
    loadAddress_Residence: "",
    loadAddress_Comments: "",

    unloadAddress_Directory: "",
    unloadAddress_ReferenceCustomer: "",
    unloadAddress_CompanyName: "",
    unloadCountry: "",
    unloadAddress_ContactName: "",
    unloadPostalCode: "",
    unloadAddress_HouseNumber: "",
    unloadAddress_DeliveryDate: "",
    unloadAddress_DeliveryTime: { startTime: "", endTime: "" },
    unloadAddress_PhoneNumber: "",
    unloadAddress: "",
    unloadAddress_IssuedDate: "",
    unloadAddress_Residence: "",
    unloadAddress_Comments: "",
    comments: "",
    comments_order: "",
    document1: null,
    documents: null,
    isInsuranceChecked: false,
    selectedTemplate: "",
  });
  // console.log("formData", formData);

  const [pcsOfPkg, setPcsOfPkg] = useState();

  const [errors, setErrors] = useState({
    name: "",
    email: "",
  });

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  useEffect(() => {
    const calculateTotals = () => {
      // Calculate Sub Total and separate discountable base services
      let subTotal = 0;
      let discountableSubTotal = 0;

      formData.services.forEach((service) => {
        const totalForService =
          parseFloat(service.numberOfItem || 1) *
          parseFloat(service.exclVAT || 0);
        subTotal += totalForService;

        const desc = (service.description || "").trim().toLowerCase();
        const isTaxOrDuty =
          desc === "vat" ||
          desc.includes("duty") ||
          desc.includes("duties") ||
          desc.includes("tax");

        if (!isTaxOrDuty) {
          discountableSubTotal += totalForService;
        }
      });

      // Calculate Discount — applies only to base services subtotal, excluding VAT/Duties/Taxes
      const rawDiscount = parseFloat(discountValue) || 0;
      let discountAmount = 0;
      if (rawDiscount > 0) {
        if (discountType === "percentage") {
          discountAmount = (discountableSubTotal * rawDiscount) / 100;
        } else {
          discountAmount = rawDiscount;
        }
        discountAmount = Math.min(discountAmount, discountableSubTotal);
      }
      const discountedSubTotal = subTotal - discountAmount;

      // Calculate VAT Amount (calculated on base subtotal, NOT discounted)
      const vatPercentage = parseFloat(formData.vatPercentage || 0);
      const vatAmount =
        vatPercentage === 0 ? 0 : (subTotal * vatPercentage) / 100;

      // Calculate Total including VAT
      let total = discountedSubTotal + vatAmount;

      // Add insurance if checked
      if (formData.isInsuranceChecked) {
        const insuranceValue = parseFloat(formData.insurance || 0);
        total += insuranceValue;
      }

      // Discount metadata
      const discountData = discountAmount > 0
        ? {
            type: discountType,
            value: rawDiscount,
            amount: parseFloat(discountAmount.toFixed(2)),
            servicesSubtotalBeforeDiscount: discountableSubTotal,
          }
        : null;

      // Update state
      setFormData((prevData) => ({
        ...prevData,
        subTotal: subTotal.toFixed(2),
        vatAmount: vatAmount.toFixed(2),
        total: total.toFixed(2),
        discount: discountData,
      }));
    };

    calculateTotals();
  }, [
    formData.services,
    formData.vatPercentage,
    formData.isInsuranceChecked,
    formData.insurance,
    discountType,
    discountValue,
  ]);

  const handleDeleteFile = (index) => {
    setFormData((prevData) => {
      const currentDocs = prevData.documents || [];
      const updatedDocs = currentDocs.filter((_, i) => i !== index);
      return {
        ...prevData,
        documents: updatedDocs,
        docFiles: updatedDocs,
      };
    });
    toast.success("File deleted successfully!");
  };

  const handleFileChange = async (e, fieldName) => {
    const fileInput = e.target;
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      console.error("No files selected.");
      return;
    }

    const files = Array.from(fileInput.files);
    const uploadedFiles = [];

    setLoading(true);

    try {
      for (const file of files) {
        const storageRef = ref(storage, `shipmentDoc/${file.name}`);
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);

        uploadedFiles.push({ name: file.name, url: downloadURL });
      }

      // Update the formData with the array of uploaded files
      setFormData((prevData) => {
        const existingDocs = prevData.documents || prevData.docFiles || [];
        const nextDocs = [...existingDocs, ...uploadedFiles];
        return {
          ...prevData,
          documents: nextDocs,
          docFiles: nextDocs,
        };
      });

      toast.success(`${files.length} file(s) uploaded successfully!`);
    } catch (error) {
      console.error("Error uploading files:", error);
      toast.error("Error uploading files: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    multiple: true,
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
      "application/vnd.ms-excel": [".xls"],
      "application/pdf": [".pdf"],
      "text/csv": [".csv"],
    },
    onDrop: (acceptedFiles) => {
      const allowedFiles = acceptedFiles.filter(isFileAllowed);
      if (allowedFiles.length > 0) {
        handleFileChange({ target: { files: allowedFiles } }, "documents");
      }
      if (allowedFiles.length < acceptedFiles.length) {
        toast.error("Some files were rejected. Only Excel, PDF, and CSV files are allowed.");
      }
    },
  });

  const { data, isLoading, refetch } = useQuery(
    ["shipment", id],
    async () => {
      const res = await getQuote(id);
      const normalizedDocs = res.documents || res.docFiles || [];
      const existingDiscount = res.discount || res.tradeOSData?.discount || null;
      if (existingDiscount) {
        setDiscountType(existingDiscount.type || "percentage");
        setDiscountValue(existingDiscount.value !== undefined ? existingDiscount.value : "");
      }
      setFormData({
        ...res,
        documents: normalizedDocs,
        docFiles: normalizedDocs,
        // Normalize legacy field names to current ones
        loadPostalCode: res.loadPostalCode ?? res.loadAddressPostalCode ?? "",
        isInsuranceChecked: res.isInsuranceChecked || false,
        selectedTemplate: res.selectedTemplate || "",
        discount: existingDiscount,
      });
      return res;
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!id,
    }
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "comments") {
      // If comments is an array, join it into a string
      const commentsString = Array.isArray(formData.comments_order)
        ? formData.comments_order.map((c) => `${c.user}: ${c.message}`).join("\n")
        : value;

      setFormData((prevData) => ({
        ...prevData,
        comments_order: commentsString,
      }));
    } else if (name === "vatPercentage") {
      const numValue = parseFloat(value);
      if (value === "" || (numValue >= 0 && /^\d*\.?\d*$/.test(value))) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    setErrors((prev) => ({ ...prev, [name]: "" }));

    // Clear highlight for general, load, or unload fields when edited
    if (value !== undefined && value !== null && value !== "") {
      setInvalidFields((prev) => prev.filter((k) => k !== name));
      setInvalidLoadAddressFields((prev) => prev.filter((k) => k !== name));
      setInvalidUnloadAddressFields((prev) => prev.filter((k) => k !== name));
    }

    if (name === "email" && value.trim() !== "") {
      if (!validateEmail(value)) {
        setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
      }
    }
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
      toast.warning("Name and Email are required fields.");
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email format";
      toast.warning("Name and Email are required fields.");
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };
  // Keep invalid highlights visible until the user fixes them
  // (no auto-clear timer).

  const handlePcsOfPkgInput = (index, field, e) => {
    const { value } = e.target;

    if (value === "" || (/^\d*\.?\d*$/.test(value) && parseFloat(value) > 0)) {
      setFormData((prevData) => {
        const newData = { ...prevData };
        const pcsPackage = [...newData.pcsPackage];

        if (pcsPackage[index]) {
          if (field === "quantity") {
            pcsPackage[index][field] = value;
          } else {
            pcsPackage[index][field].value = value;
          }
        }

        newData.pcsPackage = pcsPackage;
        return newData;
      });
    }
  };

  const updateAllUnits = (unit) => {
    setFormData((prevData) => {
      const newData = { ...prevData };
      newData.pcsPackage = newData.pcsPackage.map((pkg) => ({
        ...pkg,
        length: { ...pkg.length, unit },
        width: { ...pkg.width, unit },
        height: { ...pkg.height, unit },
      }));
      return newData;
    });
  };

  const handleUnitChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      if (pcsPackage[index]) {
        if (field === "weight") {
          // Update only the weight unit
          pcsPackage[index].weight.unit = value;
        } else {
          // Update length, width, and height units together
          pcsPackage[index].length.unit = value;
          pcsPackage[index].width.unit = value;
          pcsPackage[index].height.unit = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };

  useEffect(() => {
    const total = formData.pcsPackage.reduce((acc, pcs) => {
      const weightValue =
        parseFloat(pcs.quantity || 1) * parseFloat(pcs.weight.value || 0);
      return acc + weightValue;
    }, 0);

    setTotalWeight(total); // Update totalWeight state with numeric value
    setFormData((prevData) => ({
      ...prevData,
      totalWeight: total, // Set totalWeight field in formData with numeric value
    }));
  }, [formData.pcsPackage, totalWeight]);

  const handleRemovePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: prevData.pcsPackage.slice(0, -1), // Remove the last added package
    }));
  };

  const handleAddMorePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: [
        ...prevData.pcsPackage,
        {
          quantity: "", // Initialize quantity for each new item
          weight: { value: "", unit: "Kg" },
          length: { value: "", unit: "cm" },
          width: { value: "", unit: "cm" },
          height: { value: "", unit: "cm" },
        },
      ],
    }));
  };

  const handleOrderDetailsChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      orderDetails: {
        ...prevData.orderDetails,
        [name]: value,
      },
    }));

    // Clear field-level invalid flag when user fixes it
    if (value) {
      setInvalidFields((prev) => prev.filter((k) => k !== name));
    }
  };

  // if (isLoading) {
  //   return <Loader />;
  // }

  const downloadPDF = async () => {
    let newInvalidFields = [];
    let newInvalidLoadAddressFields = [];
    let newInvalidUnloadAddressFields = [];

    // Validate required fields
    const requiredFields = ["name", "email", "postalCode", "address"];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      newInvalidFields = [...newInvalidFields, ...missingFields];
      toast.error(`Please fill in all required fields: ${missingFields.join(", ")}`);
      setInvalidFields(newInvalidFields);
      return;
    }

    if (!formData.orderDetails?.subStatus) {
      setSubStatusError(true);
      toast.error("Please select an Order Sub-Status");
      return;
    } else {
      setSubStatusError(false);
    }

    if (!formData.orderDetails?.orderDate) {
      newInvalidFields.push("orderDate");
      toast.error("Please select an Order Date");
    }
    if (!formData.orderDetails?.eta) {
      newInvalidFields.push("eta");
      toast.error("Please select an ETA");
    }
    if (formData.vatPercentage !== "" && formData.vatPercentage !== undefined) {
      const vatPercentage = parseFloat(formData.vatPercentage);
      if (isNaN(vatPercentage) || vatPercentage < 0) {
        newInvalidFields.push("vatPercentage");
        toast.error("VAT Percentage must be greater than or equal to 0");
      }
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newInvalidFields.push("email");
      toast.error("Please enter a valid email address");
    }

    // Validate Cargo Value and CIF Value
    if (!formData.cargoValue.value || parseFloat(formData.cargoValue.value) <= 0) {
      newInvalidFields.push("cargoValue");
      toast.error("Cargo Value must be a positive number");
    }
    if (!formData.cifValue.value || parseFloat(formData.cifValue.value) <= 0) {
      newInvalidFields.push("cifValue");
      toast.error("CIF Value must be a positive number");
    }

    // Validate pcsPackage
    formData.pcsPackage.forEach((pkg, index) => {
      ["quantity", "weight", "length", "width", "height"].forEach((field) => {
        const value = field === "quantity" ? pkg[field] : pkg[field].value;
        if (!value || parseFloat(value) <= 0) {
          newInvalidFields.push(`${field}-${index}`);
          toast.error(`${field} for package ${index + 1} must be a positive number`);
        }
      });
    });

    // Validate loadAddress
    const loadAddressRequiredFields = [
      "loadCountry",
      "loadAddress_ReferenceCustomer",
      "loadPostalCode",
      "loadAddress_PickUpDate",
      "loadAddress",
    ];

    loadAddressRequiredFields.forEach((field) => {
      if (!formData[field]) {
        newInvalidLoadAddressFields.push(field);
      }
    });

    if (!formData.loadAddress_PickUpTime?.startTime || !formData.loadAddress_PickUpTime?.endTime) {
      newInvalidLoadAddressFields.push("loadAddress_PickUpTime");
    }

    // Validate unloadAddress
    const unloadAddressRequiredFields = [
      "unloadCountry",
      "unloadPostalCode",
      "unloadAddress_DeliveryDate",
      "unloadAddress",
      "unloadAddress_ReferenceCustomer",
    ];

    unloadAddressRequiredFields.forEach((field) => {
      if (!formData[field]) {
        newInvalidUnloadAddressFields.push(field);
      }
    });

    if (!formData.unloadAddress_DeliveryTime?.startTime || !formData.unloadAddress_DeliveryTime?.endTime) {
      newInvalidUnloadAddressFields.push("unloadAddress_DeliveryTime");
    }

    if (newInvalidFields.length > 0 || newInvalidLoadAddressFields.length > 0 || newInvalidUnloadAddressFields.length > 0) {
      setInvalidFields(newInvalidFields);
      setInvalidLoadAddressFields(newInvalidLoadAddressFields);
      setInvalidUnloadAddressFields(newInvalidUnloadAddressFields);
      return;
    }
    try {
      setLoadingPdf(true);

      formData.comments = formData.comments_order;
      // Call the function to generate the PDF
      const blob = await DelieveryNote(formData);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "deliveryNote.pdf";

      // Programmatically trigger the download
      link.click();
    } catch (error) {
      console.error("Error downloading PDF:", error);
      // Handle error as needed, e.g., display a toast message
      toast.error("Error downloading PDF. Please try again later.");
    } finally {
      // Ensure loading state is reset regardless of success or failure
      setLoadingPdf(false);
    }
  };

  const downloadQuote = async () => {
    let newInvalidFields = [];
    let newInvalidLoadAddressFields = [];
    let newInvalidUnloadAddressFields = [];

    // Validate required fields
    const requiredFields = ["name", "email", "postalCode", "address"];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      newInvalidFields = [...newInvalidFields, ...missingFields];
      toast.error(`Please fill in all required fields: ${missingFields.join(", ")}`);
      setInvalidFields(newInvalidFields);
      return;
    }

    if (!formData.orderDetails?.subStatus) {
      setSubStatusError(true);
      toast.error("Please select an Order Sub-Status");
      return;
    } else {
      setSubStatusError(false);
    }

    if (!formData.orderDetails?.orderDate) {
      newInvalidFields.push("orderDate");
      toast.error("Please select an Order Date");
    }
    if (!formData.orderDetails?.eta) {
      newInvalidFields.push("eta");
      toast.error("Please select an ETA");
    }
    if (formData.vatPercentage !== "" && formData.vatPercentage !== undefined) {
      const vatPercentage = parseFloat(formData.vatPercentage);
      if (isNaN(vatPercentage) || vatPercentage < 0) {
        newInvalidFields.push("vatPercentage");
        toast.error("VAT Percentage must be greater than or equal to 0");
      }
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newInvalidFields.push("email");
      toast.error("Please enter a valid email address");
    }

    // Validate Cargo Value and CIF Value
    if (!formData.cargoValue.value || parseFloat(formData.cargoValue.value) <= 0) {
      newInvalidFields.push("cargoValue");
      toast.error("Cargo Value must be a positive number");
    }
    if (!formData.cifValue.value || parseFloat(formData.cifValue.value) <= 0) {
      newInvalidFields.push("cifValue");
      toast.error("CIF Value must be a positive number");
    }

    // Validate pcsPackage
    formData.pcsPackage.forEach((pkg, index) => {
      ["quantity", "weight", "length", "width", "height"].forEach((field) => {
        const value = field === "quantity" ? pkg[field] : pkg[field].value;
        if (!value || parseFloat(value) <= 0) {
          newInvalidFields.push(`${field}-${index}`);
          toast.error(`${field} for package ${index + 1} must be a positive number`);
        }
      });
    });

    // Validate loadAddress
    const loadAddressRequiredFields = [
      "loadCountry",
      "loadAddress_ReferenceCustomer",
      "loadPostalCode",
      "loadAddress_PickUpDate",
      "loadAddress",
    ];

    loadAddressRequiredFields.forEach((field) => {
      if (!formData[field]) {
        newInvalidLoadAddressFields.push(field);
      }
    });

    if (!formData.loadAddress_PickUpTime?.startTime || !formData.loadAddress_PickUpTime?.endTime) {
      newInvalidLoadAddressFields.push("loadAddress_PickUpTime");
    }

    // Validate unloadAddress
    const unloadAddressRequiredFields = [
      "unloadCountry",
      "unloadPostalCode",
      "unloadAddress_DeliveryDate",
      "unloadAddress",
      "unloadAddress_ReferenceCustomer",
    ];

    unloadAddressRequiredFields.forEach((field) => {
      if (!formData[field]) {
        newInvalidUnloadAddressFields.push(field);
      }
    });

    if (!formData.unloadAddress_DeliveryTime?.startTime || !formData.unloadAddress_DeliveryTime?.endTime) {
      newInvalidUnloadAddressFields.push("unloadAddress_DeliveryTime");
    }

    if (newInvalidFields.length > 0 || newInvalidLoadAddressFields.length > 0 || newInvalidUnloadAddressFields.length > 0) {
      setInvalidFields(newInvalidFields);
      setInvalidLoadAddressFields(newInvalidLoadAddressFields);
      setInvalidUnloadAddressFields(newInvalidUnloadAddressFields);
      return;
    }
    try {
      setPdfLoading(true);
      const blob = await generatePDF(formData);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      const fileName = `${formData.quoteNumber}.pdf`;
      link.download = fileName;
      link.click();
    } catch (error) {
      console.error("Error downloading PDF:", error);
      toast.error("Error downloading PDF. Please try again later.");
    } finally {
      setPdfLoading(false);
    }
  };

  const handleDeleteDoc = async (id) => {
    try {
      const userDocRef = doc(db, "quotes", id);
      const orderNumberRef = await getDoc(userDocRef);
      const quoteData = orderNumberRef.data();

      await updateDoc(userDocRef, { document1: "" });
      toast.success(" Document Deleted successfully!");
      refetch();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    }
  };
  const handleCurrencyChange = (e) => {
    const newCurrency = e.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      cargoValue: {
        ...prevFormData.cargoValue,
        currency: newCurrency,
      },
      cifValue: {
        ...prevFormData.cifValue,
        currency: newCurrency,
      },
    }));
  };

  const handleUpdateData = async (e) => {
    e.preventDefault();

    setAttemptedSubmit(true);
    // Collect invalid fields across the whole form in one pass
    let newInvalidFields = [];
    let newInvalidLoadAddressFields = [];
    let newInvalidUnloadAddressFields = [];
    let hasError = false;

    // Validate required top-level fields
    const requiredFields = ["name", "email", "postalCode", "address"];
    const missingFields = requiredFields.filter((field) => !formData[field]);
    if (missingFields.length > 0) {
      newInvalidFields = [...newInvalidFields, ...missingFields];
      hasError = true;
    }

    // Order sub-status
    if (!formData.orderDetails?.subStatus) {
      setSubStatusError(true);
      hasError = true;
    } else {
      setSubStatusError(false);
    }

    // Order dates
    if (!formData.orderDetails?.orderDate) {
      newInvalidFields.push("orderDate");
      hasError = true;
    }
    if (!formData.orderDetails?.eta) {
      newInvalidFields.push("eta");
      hasError = true;
    }

    // VAT is optional; validate only if provided and non-empty
    if (formData.vatPercentage !== "" && formData.vatPercentage !== undefined) {
      const vatPercentage = parseFloat(formData.vatPercentage);
      if (isNaN(vatPercentage) || vatPercentage < 0) {
        newInvalidFields.push("vatPercentage");
        hasError = true;
      }
    }

    // Email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newInvalidFields.push("email");
      hasError = true;
    }

    // Cargo and CIF values
    if (!formData.cargoValue.value || parseFloat(formData.cargoValue.value) <= 0) {
      newInvalidFields.push("cargoValue");
      hasError = true;
    }
    if (!formData.cifValue.value || parseFloat(formData.cifValue.value) <= 0) {
      newInvalidFields.push("cifValue");
      hasError = true;
    }

    // pcsPackage fields
    formData.pcsPackage.forEach((pkg, index) => {
      ["quantity", "weight", "length", "width", "height"].forEach((field) => {
        const value = field === "quantity" ? pkg[field] : pkg[field].value;
        if (!value || parseFloat(value) <= 0) {
          newInvalidFields.push(`${field}-${index}`);
          hasError = true;
        }
      });
    });

    // Load address required
    const loadAddressRequiredFields = [
      "loadCountry",
      "loadAddress_ReferenceCustomer",
      "loadPostalCode",
      "loadAddress_PickUpDate",
      "loadAddress",
    ];
    loadAddressRequiredFields.forEach((field) => {
      if (!formData[field]) newInvalidLoadAddressFields.push(field);
    });
    if (!formData.loadAddress_PickUpTime?.startTime || !formData.loadAddress_PickUpTime?.endTime) {
      newInvalidLoadAddressFields.push("loadAddress_PickUpTime");
    }

    // Optional phone validation
    if (formData.loadAddress_PhoneNumber) {
      if (!/^(\+)?[0-9]{0,20}$/.test(formData.loadAddress_PhoneNumber)) {
        newInvalidLoadAddressFields.push("loadAddress_PhoneNumber");
      }
    }

    // Unload address required
    const unloadAddressRequiredFields = [
      "unloadCountry",
      "unloadPostalCode",
      "unloadAddress_DeliveryDate",
      "unloadAddress",
      "unloadAddress_ReferenceCustomer",
    ];
    unloadAddressRequiredFields.forEach((field) => {
      if (!formData[field]) newInvalidUnloadAddressFields.push(field);
    });
    if (!formData.unloadAddress_DeliveryTime?.startTime || !formData.unloadAddress_DeliveryTime?.endTime) {
      newInvalidUnloadAddressFields.push("unloadAddress_DeliveryTime");
    }
    if (formData.unloadAddress_PhoneNumber) {
      if (!/^(\+)?[0-9]{0,20}$/.test(formData.unloadAddress_PhoneNumber)) {
        newInvalidUnloadAddressFields.push("unloadAddress_PhoneNumber");
      }
    }

    // If any invalids collected, set states once and show a single toast
    if (
      newInvalidFields.length > 0 ||
      newInvalidLoadAddressFields.length > 0 ||
      newInvalidUnloadAddressFields.length > 0 ||
      hasError
    ) {
      setInvalidFields(newInvalidFields);
      setInvalidLoadAddressFields(newInvalidLoadAddressFields);
      setInvalidUnloadAddressFields(newInvalidUnloadAddressFields);

      // Map internal keys to user-friendly labels
      const toLabel = (key) => {
        // Package-specific fields e.g. weight-0
        const pkgMatch = key && key.match(/^(quantity|weight|length|width|height)-(\d+)$/);
        if (pkgMatch) {
          const field = pkgMatch[1];
          const idx = Number(pkgMatch[2]) + 1;
          const map = {
            quantity: "Quantity",
            weight: "Weight",
            length: "Length",
            width: "Width",
            height: "Height",
          };
          return `${map[field]} (package #${idx})`;
        }

        const map = {
          name: "Name",
          email: "Email",
          postalCode: "Postal Code",
          address: "Address",
          orderDate: "Order Date",
          eta: "ETA",
          vatPercentage: "VAT Percentage",
          cargoValue: "Cargo Value",
          cifValue: "CIF Value",
          // Load address
          loadCountry: "Pickup Country",
          loadAddress_ReferenceCustomer: "Pickup Reference Customer",
          loadPostalCode: "Pickup Postal Code",
          loadAddress_PickUpDate: "Pickup Date",
          loadAddress: "Pickup Address",
          loadAddress_PickUpTime: "Pickup Time",
          loadAddress_PhoneNumber: "Pickup Phone Number",
          // Unload address
          unloadCountry: "Delivery Country",
          unloadPostalCode: "Delivery Postal Code",
          unloadAddress_DeliveryDate: "Delivery Date",
          unloadAddress: "Delivery Address",
          unloadAddress_ReferenceCustomer: "Delivery Reference Customer",
          unloadAddress_DeliveryTime: "Delivery Time",
          unloadAddress_PhoneNumber: "Delivery Phone Number",
        };
        return map[key] || key;
      };

      // Build concise message listing the first few missing/invalid fields
      const allInvalid = Array.from(
        new Set([
          ...newInvalidFields,
          ...newInvalidLoadAddressFields,
          ...newInvalidUnloadAddressFields,
        ])
      ).filter(Boolean);

      const labels = allInvalid.map(toLabel);
      // Log full detail for debugging
      // eslint-disable-next-line no-console
      console.error("Invalid fields:", {
        invalidFields: newInvalidFields,
        invalidLoadAddressFields: newInvalidLoadAddressFields,
        invalidUnloadAddressFields: newInvalidUnloadAddressFields,
      });
      const firstFew = labels.slice(0, 5);
      const remaining = labels.length - firstFew.length;
      const msg = firstFew.length
        ? `Please fill the required fields: ${firstFew.join(", ")}${remaining > 0 ? ` and ${remaining} more.` : "."}`
        : "Please fill the required fields.";
      toast.error(msg);
      return;
    }
    // Save data
    const serviceErrors = {};
    // formData.services.forEach((service, index) => {
    //   if (!service.numberOfItem || parseFloat(service.numberOfItem) <= 0) {
    //     serviceErrors[`service_${index}_numberOfItem`] = true;
    //   }
    //   if (!service.description || service.description.trim() === "") {
    //     serviceErrors[`service_${index}_description`] = true;
    //   }
    //   // if (!service.exclVAT || parseFloat(service.exclVAT) <= 0) {
    //   //   serviceErrors[`service_${index}_exclVAT`] = true;
    //   // }
    // });

    // if (Object.keys(serviceErrors).length > 0) {
    //   setValidationErrors((prev) => ({ ...prev, ...serviceErrors }));
    //   toast.error(
    //     "Please fill in all required fields in the services section."
    //   );
    //   return;
    // }
    // if (newInvalidFields.length > 0) {
    //   setInvalidFields(newInvalidFields);
    //   return;
    // }

    try {
      setLoading(true);
      const userDocRef = doc(db, "quotes", id);
      const normalizedDocs = formData.documents || formData.docFiles || [];
      await updateDoc(userDocRef, {
        ...formData,
        documents: normalizedDocs,
        docFiles: normalizedDocs,
        isInsuranceChecked: formData.isInsuranceChecked,
        discount: formData.discount || null,
      });
      setAttemptedSubmit(false);

      await api.post("/notifications", {
        title: "Shipment Status and Details Updated",
        message: `The status, order, pickup, and delivery details of your shipment (Quote #${formData.quoteNumber}) have been updated by the admin.`,
        linkText: "View Quote",
        link: `/myShipment`,
        role: "user",
        userId: formData.userId,
        quoteNumber: formData.quoteNumber,
        type: "shipments-update"
      });

      toast.success("Quotes data updated successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // const [copied, setCopied] = useState(false);

  const handleCopy = () => {

    let newInvalidFields = [];
    let newInvalidLoadAddressFields = [];
    let newInvalidUnloadAddressFields = [];

    // Validate required fields
    const requiredFields = ["name", "email", "postalCode", "address"];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      newInvalidFields = [...newInvalidFields, ...missingFields];
      toast.error(`Please fill in all required fields: ${missingFields.join(", ")}`);
      setInvalidFields(newInvalidFields);
      return;
    }

    if (!formData.orderDetails?.subStatus) {
      setSubStatusError(true);
      toast.error("Please select an Order Sub-Status");
      return;
    } else {
      setSubStatusError(false);
    }

    if (!formData.orderDetails?.orderDate) {
      newInvalidFields.push("orderDate");
      toast.error("Please select an Order Date");
    }
    if (!formData.orderDetails?.eta) {
      newInvalidFields.push("eta");
      toast.error("Please select an ETA");
    }
    if (formData.vatPercentage !== "" && formData.vatPercentage !== undefined) {
      const vatPercentage = parseFloat(formData.vatPercentage);
      if (isNaN(vatPercentage) || vatPercentage < 0) {
        newInvalidFields.push("vatPercentage");
        toast.error("VAT Percentage must be greater than or equal to 0");
      }
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newInvalidFields.push("email");
      toast.error("Please enter a valid email address");
    }

    // Validate Cargo Value and CIF Value
    if (!formData.cargoValue.value || parseFloat(formData.cargoValue.value) <= 0) {
      newInvalidFields.push("cargoValue");
      toast.error("Cargo Value must be a positive number");
    }
    if (!formData.cifValue.value || parseFloat(formData.cifValue.value) <= 0) {
      newInvalidFields.push("cifValue");
      toast.error("CIF Value must be a positive number");
    }

    // Validate pcsPackage
    formData.pcsPackage.forEach((pkg, index) => {
      ["quantity", "weight", "length", "width", "height"].forEach((field) => {
        const value = field === "quantity" ? pkg[field] : pkg[field].value;
        if (!value || parseFloat(value) <= 0) {
          newInvalidFields.push(`${field}-${index}`);
          toast.error(`${field} for package ${index + 1} must be a positive number`);
        }
      });
    });

    // Validate loadAddress
    const loadAddressRequiredFields = [
      "loadCountry",
      "loadAddress_ReferenceCustomer",
      "loadPostalCode",
      "loadAddress_PickUpDate",
      "loadAddress",
    ];

    loadAddressRequiredFields.forEach((field) => {
      if (!formData[field]) {
        newInvalidLoadAddressFields.push(field);
      }
    });

    if (!formData.loadAddress_PickUpTime?.startTime || !formData.loadAddress_PickUpTime?.endTime) {
      newInvalidLoadAddressFields.push("loadAddress_PickUpTime");
    }

    // Validate unloadAddress
    const unloadAddressRequiredFields = [
      "unloadCountry",
      "unloadPostalCode",
      "unloadAddress_DeliveryDate",
      "unloadAddress",
      "unloadAddress_ReferenceCustomer",
    ];

    unloadAddressRequiredFields.forEach((field) => {
      if (!formData[field]) {
        newInvalidUnloadAddressFields.push(field);
      }
    });

    if (!formData.unloadAddress_DeliveryTime?.startTime || !formData.unloadAddress_DeliveryTime?.endTime) {
      newInvalidUnloadAddressFields.push("unloadAddress_DeliveryTime");
    }

    if (newInvalidFields.length > 0 || newInvalidLoadAddressFields.length > 0 || newInvalidUnloadAddressFields.length > 0) {
      setInvalidFields(newInvalidFields);
      setInvalidLoadAddressFields(newInvalidLoadAddressFields);
      setInvalidUnloadAddressFields(newInvalidUnloadAddressFields);
      return;
    }

    const linkToCopy = `${window.location.origin}/trackshipment/${formData.trackingNumber}`;
    navigator.clipboard
      .writeText(linkToCopy)
      .then(() => {
        toast.success("Link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const UploadedFiles = ({ files, onDelete }) => (
    <div className="mx-[30px] mb-4">
      <h3 className="font-bold text-lg mb-2">Uploaded Files:</h3>
      <ul className="list-disc pl-5">
        {files.map((file, index) => (
          <li key={index} className="flex items-center justify-between mb-2">
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              {file.name}
            </a>
            <button
              onClick={() => onDelete(index)}
              className="text-red-500 hover:text-red-700"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );

  const formatCreationDate = (dateString) => {
    const date = new Date(dateString);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid date'; // or handle the error as needed
    }

    return date.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  };

  // console.log(formData)

  return (
    <DashboardLayout>
      <div className="flex">
        {/* <div className="hidden sm:block">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full border border-red">
          <Header title="Book Shipment" />
          {/* Use the main layout scroll; this section itself won't create a second scrollbar */}
          <div className="p-2 sm:p-4 bg-cus-gray">
            <div className="mx-auto bg-white border rounded-md sm:p-4">
              <div>
                <h2 className="mx-[30px] font-bold text-xl mt-4">
                  Customer Information{" "}
                </h2>
                <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="name"
                    >
                      Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Name"
                      name="name"
                      onChange={handleChange}
                      value={formData?.name || ""}
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("name") ? "border-red-500" : ""
                        }`}
                      id="name"
                    />
                    {errors.name && (
                      <p className="text-red-500 text-xs mt-1">{errors.name}</p>
                    )}
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="companyname"
                    >
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Email Address"
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("email") ? "border-red-500" : ""
                        }`}
                      id="email"
                      name="email"
                      onChange={handleChange}
                      value={formData?.email || ""}
                    />
                    {errors.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.email}
                      </p>
                    )}
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="addressone"
                    >
                      Postal Code <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Postal Code"
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("postalCode")
                        ? "border-red-500"
                        : ""
                        }`}
                      onChange={handleChange}
                      value={formData.postalCode}
                      name="postalCode"
                      id="postalCode"
                    />
                  </div>
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="addresstwo"
                    >
                      Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="address "
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("address")
                        ? "border-red-500"
                        : ""
                        }`}
                      id="address"
                      name="address"
                      onChange={handleChange}
                      value={formData?.address}
                    />
                  </div>
                </div>

                <div className="flex mx-[30px] gap-4">
                  <div className="flex flex-col gap-1 w-1/2 py-2">
                    <label className="w-full text-sm font-normal" htmlFor="name">
                      Transportation Mode
                    </label>
                    <select
                      className="w-full h-8 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      name="air"
                      onChange={handleChange}
                      value={formData?.modeOfTransfer}
                    >
                      <option value="By Road">By Road</option>
                      <option value="By Sea">By Sea</option>
                      <option value="By Air">By Air</option>
                    </select>
                  </div>

                  <div className="flex flex-col gap-1 w-1/2 py-2">
                    <label className="w-full text-sm font-normal" htmlFor="creationDate">
                      Shipment Created Date
                    </label>
                    <input
                      type="text"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none bg-gray-100"
                      id="creationDate"
                      value={formatCreationDate(formData.shipmentCreatedDate)}
                      name="creationDate"
                      disabled
                    />
                  </div>
                </div>


                <div className="mx-[30px] grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor="cargoValue"
                    >
                      Cargo Value <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="text"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes("cargoValue")
                          ? "border-red-500"
                          : ""
                          }`}
                        name="cargoValue"
                        id="cargoValue"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            value === "" ||
                            (/^\d*\.?\d*$/.test(value) && parseFloat(value) > 0)
                          ) {
                            setFormData((prevFormData) => ({
                              ...prevFormData,
                              cargoValue: {
                                ...prevFormData.cargoValue,
                                value: value,
                              },
                            }));
                          }
                        }}
                        value={formData.cargoValue.value || ""}
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name="cargoValue-currency"
                        id="cargoValue-currency"
                        onChange={handleCurrencyChange}
                        value={formData.cargoValue.currency || ""}
                      >
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                      </select>
                    </div>
                  </div>

                  <div className="flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor="cifValue"
                    >
                      CIF Value <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center gap-1">
                      <CIFValue formData={formData} setFormData={setFormData} />

                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name="cifValue-currency"
                        id="cifValue-currency"
                        onChange={handleCurrencyChange}
                        value={formData.cifValue.currency || ""}
                      >
                        <option value="USD">USD</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                      </select>
                    </div>
                  </div>
                </div>

                <h2 className="mx-[30px] font-bold text-xl mt-4">Goods</h2>

                {/* Render input fields based on pcsOfPkg value */}
                {formData.pcsPackage.map((formItem, index) => (
                  <div
                    key={index}
                    className="mx-[30px] flex-wrap justify-between flex items-center gap-5"
                  >
                    {/* Weight */}
                    <div className="w-full lg:w-[10%] flex flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`amount-${index}`}
                      >
                        Quantity <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`quantity-${index}`)
                          ? "border-red-500"
                          : ""
                          }`}
                        id={`quantity-${index}`}
                        onChange={(e) =>
                          handlePcsOfPkgInput(index, "quantity", e)
                        }
                        value={formData.pcsPackage[index]?.quantity || ""}
                      />
                    </div>
                    <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`weight-${index}`}
                      >
                        Weight <span className="text-red-500">*</span>
                      </label>
                      <div className="flex items-center">
                        <input
                          type="number"
                          className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`weight-${index}`)
                            ? "border-red-500"
                            : ""
                            }`}
                          name={`weight-${index}`}
                          id={`weight-${index}`}
                          onChange={(e) =>
                            handlePcsOfPkgInput(index, "weight", e)
                          }
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          min="0.01"
                          step="0.01"
                          value={formData.pcsPackage[index]?.weight.value || ""}
                        />
                        <select
                          className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name={`weight-unit-${index}`}
                          id={`weight-unit-${index}`}
                          onChange={(e) => handleUnitChange(index, "weight", e)}
                          value={formData.pcsPackage[index]?.weight.unit || ""}
                        >
                          <option value="kg">kg</option>
                          <option value="lbs">lbs</option>
                        </select>
                      </div>
                    </div>

                    {/* Length */}
                    <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`length-${index}`}
                      >
                        Length <span className="text-red-500">*</span>
                      </label>
                      <div className="flex items-center">
                        <input
                          type="number"
                          className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`length-${index}`)
                            ? "border-red-500"
                            : ""
                            }`}
                          name={`length-${index}`}
                          id={`length-${index}`}
                          onChange={(e) =>
                            handlePcsOfPkgInput(index, "length", e)
                          }
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          min="0.01"
                          step="0.01"
                          value={formData.pcsPackage[index]?.length.value || ""}
                        />
                        <select
                          className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name={`length-unit-${index}`}
                          id={`length-unit-${index}`}
                          onChange={(e) => handleUnitChange(index, "length", e)}
                          value={formData.pcsPackage[index]?.length.unit || ""}
                        >
                          <option value="cm">cm</option>
                          <option value="in">in</option>
                        </select>
                      </div>
                    </div>
                    {/* Width */}
                    <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`width-${index}`}
                      >
                        Width <span className="text-red-500">*</span>
                      </label>
                      <div className="flex items-center">
                        <input
                          type="number"
                          className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`width-${index}`)
                            ? "border-red-500"
                            : ""
                            }`}
                          name={`width-${index}`}
                          id={`width-${index}`}
                          onChange={(e) =>
                            handlePcsOfPkgInput(index, "width", e)
                          }
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          min="0.01"
                          step="0.01"
                          value={formData.pcsPackage[index]?.width.value || ""}
                        />
                        <select
                          className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name={`width-unit-${index}`}
                          id={`width-unit-${index}`}
                          onChange={(e) => handleUnitChange(index, "width", e)}
                          value={formData.pcsPackage[index]?.width.unit || ""}
                        >
                          <option value="cm">cm</option>
                          <option value="in">in</option>
                        </select>
                      </div>
                    </div>
                    {/* Height */}
                    <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                      <label
                        className="w-full text-sm font-normal"
                        htmlFor={`height-${index}`}
                      >
                        Height <span className="text-red-500">*</span>
                      </label>
                      <div className="flex items-center">
                        <input
                          type="number"
                          className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${invalidFields.includes(`height-${index}`)
                            ? "border-red-500"
                            : ""
                            }`}
                          name={`height-${index}`}
                          id={`height-${index}`}
                          onChange={(e) =>
                            handlePcsOfPkgInput(index, "height", e)
                          }
                          onKeyDown={(e) => {
                            if (
                              e.key === "e" ||
                              e.key === "-" ||
                              e.key === "+"
                            ) {
                              e.preventDefault();
                            }
                          }}
                          min="0.01"
                          step="0.01"
                          value={formData.pcsPackage[index]?.height.value || ""}
                        />
                        <select
                          className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                          name={`height-unit-${index}`}
                          id={`height-unit-${index}`}
                          onChange={(e) => handleUnitChange(index, "height", e)}
                          value={formData.pcsPackage[index]?.height.unit || ""}
                        >
                          <option value="cm">cm</option>
                          <option value="in">in</option>
                        </select>
                      </div>
                    </div>
                  </div>
                ))}

                <div className="flex justify-between gap-5 items-center px-5 py-2">
                  <div className="flex gap-1 items-center">
                    <div
                      className="mx-[20px] mt- "
                      onClick={handleAddMorePcsOfpackage}
                    >
                      <FaPlus className="text-[20px] text-[#03336E] " />
                    </div>

                    <div
                      className="mx-[5px]  "
                      onClick={handleRemovePcsOfpackage}
                    >
                      <FaMinus className="text-[20px] text-[#03336E] " />
                    </div>
                  </div>

                  <div className="px-5 flex  items-center gap-5">
                    <p className="text-[14px]"> Total Weight:</p>
                    <p className="text-[14px] font-extrabold">
                      {formData.totalWeight ? formData.totalWeight : "00"}
                    </p>
                  </div>
                </div>

                <ServiceTemp
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  templateSelected={templateSelected}
                  setTemplateSelected={setTemplateSelected}
                  attemptedSubmit={attemptedSubmit}
                />

                <div className="mx-[30px] flex flex-col lg:flex-row gap-2 ">
                  <div className="w-full lg:w-[60%] bg-[#FBFCFF] p-4 rounded-lg  border border-cus-blue ">
                    {/* <h1 className=" text-[16px] font-bold ">
                            Transport Warehouse - Hoofdrop
                        </h1>

                        <p className="text-[gray] ">
                            Selling Price: $0.00 excl VAT
                        </p> */}
                    <div className="flex items-center w-full lg:w-1/2 gap-1 py-2">
                      <label className="w-full text-base font-medium">
                        VAT Percentage :
                      </label>
                      <input
                        type="number"
                        className="w-full p-2 text-sm border-2 rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name="vatPercentage"
                        placeholder="%"
                        id="vatPercentage"
                        onChange={(e) => {
                          let value = e.target.value;
                          // Disallow leading zeros except for values like 0.x
                          if (value && value.length > 1 && !value.startsWith("0.")) {
                            value = value.replace(/^0+/, "");
                            if (value === "") value = "0";
                          }
                          if (
                            value === "" ||
                            (/^\d*\.?\d*$/.test(value) && parseFloat(value) >= 0)
                          ) {
                            handleChange({ target: { name: "vatPercentage", value } });
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "e" || e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        onBlur={(e) => {
                          if (e.target.value === "") {
                            handleChange({ target: { name: "vatPercentage", value: "0" } });
                          }
                        }}
                        value={formData.vatPercentage || ""}
                        min="0"
                        step="1"
                      />
                    </div>
                    <InsuranceCheckbox
                      formData={formData}
                      setFormData={setFormData}
                    />
                  </div>

                  <div className="w-full lg:w-[40%] bg-[#FBFCFF] p-4 border rounded-lg border-cus-blue">
                    <div className="flex justify-between">
                      <div>
                        <p className="text-[14px]">Sub Total</p>
                      </div>
                      <div className="">
                        <p className="text-[14px] font-extrabold">
                          {AmountFormat(formData.subTotal, formData.currency)}
                        </p>
                      </div>
                    </div>

                    <DiscountInput
                      discountType={discountType}
                      discountValue={discountValue}
                      onDiscountTypeChange={setDiscountType}
                      onDiscountValueChange={setDiscountValue}
                      currency={formData.currency}
                      discountAmount={formData.discount?.amount || 0}
                    />

                    {formData.discount && formData.discount.amount > 0 && (
                      <div className="flex justify-between mt-1 text-orange-600">
                        <div>
                          <p className="text-[14px] font-medium">
                            Discount ({formData.discount.type === 'percentage' ? `${formData.discount.value}%` : 'Fixed'})
                          </p>
                        </div>
                        <div>
                          <p className="text-[14px] font-extrabold">
                            - {AmountFormat(formData.discount.amount, formData.currency)}
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="flex justify-between mt-1 ">
                      <div>
                        <p className="text-[14px]">Total VAT</p>
                      </div>
                      <div className="">
                        <p className="text-[14px] font-extrabold ">
                          {AmountFormat(formData.vatAmount, formData.currency)}
                        </p>
                      </div>
                    </div>

                    <div className="flex justify-between mt-4 border-t border-cus-blue ">
                      <div className="mt-2">
                        <p className="text-[14px]">Total</p>
                      </div>
                      <div className="mt-2">
                        <p className="text-[14px] font-extrabold ">
                          {AmountFormat(formData.total, formData.currency)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <>
                <h2 className="mx-[30px] font-bold  text-xl mt-8">
                  Order Details
                </h2>
                <div className="flex flex-col lg:flex-row gap-3 mx-[30px] ">
                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="orderDate"
                    >
                      Order Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none ${invalidFields.includes("orderDate")
                        ? "border-red-500 focus:border-red-500"
                        : "active:border-cus-blue focus:border-cus-blue"
                        }`}
                      id="orderDate"
                      name="orderDate"
                      onChange={handleOrderDetailsChange}
                      value={formData.orderDetails?.orderDate || ""}
                    />
                  </div>

                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="eta"
                    >
                      ETA <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none ${invalidFields.includes("eta")
                        ? "border-red-500 focus:border-red-500"
                        : "active:border-cus-blue focus:border-cus-blue"
                        }`}
                      id="eta"
                      name="eta"
                      onChange={handleOrderDetailsChange}
                      value={formData.orderDetails?.eta || ""}
                    />
                  </div>

                  <div className="flex flex-col w-full gap-1 py-2 ">
                    <label
                      className="w-full text-sm font-normal "
                      htmlFor="country"
                    >
                      Order Substatus <span className="text-red-500">*</span>
                    </label>

                    <select
                      className={`w-full h-8 text-sm border rounded-md outline-none ${subStatusError
                        ? "border-red-500 focus:border-red-500"
                        : "active:border-cus-blue focus:border-cus-blue"
                        }`}
                      id="subStatus"
                      name="subStatus"
                      onChange={(e) => {
                        handleOrderDetailsChange(e);
                        setSubStatusError(false);
                      }}
                      value={formData?.orderDetails?.subStatus || ""}
                    >
                      <option value="" disabled>
                        Select Order Sub-Status
                      </option>
                      <option value="Collection">Collection</option>
                      <option value="Compliance">Compliance</option>
                      <option value="In Transit">In Transit</option>
                      <option value="Custom Clearance">Custom Clearance</option>
                      <option value="Final Delivery">Final delivery</option>
                      <option value="Delivered">Delivered</option>
                    </select>
                    {subStatusError && (
                      <p className="text-red-500 text-xs mt-1">
                        Please select an Order Sub-Status
                      </p>
                    )}
                  </div>
                </div>

                <h2 className="mx-[30px] font-bold text-xl mt-4">Edit Order</h2>
                <h2 className="mx-[30px] font-bold text-xl mt-4">
                  Load Address
                </h2>

                <div className="mx-[30px] mt-4 ">
                  <LoadAddress
                    formData={formData}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    invalidLoadAddressFields={invalidLoadAddressFields}
                    setInvalidLoadAddressFields={setInvalidLoadAddressFields}
                  />
                </div>

                <h2 className="mx-[30px] font-bold text-xl mt-4">
                  Unload Address
                </h2>
                <div className="mx-[30px] mt-4 ">
                  <UnloadAddress
                    formData={formData}
                    handleChange={handleChange}
                    setFormData={setFormData}
                    invalidUnloadAddressFields={invalidUnloadAddressFields}
                    setInvalidUnloadAddressFields={setInvalidUnloadAddressFields}
                  />
                </div>
              </>

              <div className="flex flex-col gap-1 mx-[30px] mt-4">
                <label>Comments</label>

                <textarea
                  className="border border-[#B3C5DF] h-[300px] rounded-lg  focus:outline-none p-2 "
                  style={{ fontSize: '14px' }}
                  id="comments"
                  name="comments"
                  onChange={handleChange}
                  value={
                    Array.isArray(formData.comments_order)
                      ? formData.comments_order
                        .map((c) => `${c.user}: ${c.message}`)
                        .join("\n")
                      : formData.comments_order || ""
                  }
                  maxLength={1000}
                />
              </div>

              <div className="flex gap-3 justify-end mt-4 mx-[30px]  ">
                <button
                  className="px-10 py-2 border rounded-lg border-[#9C9C9C]"
                  onClick={handleCopy}
                >
                  <div className="text-sm flex gap-2 items-center px-2 text-black bg-white hover:scale-105 transition-all duration-300 cursor-pointer">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 85 85"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M46.71 68.2611C47.3718 68.9233 47.7435 69.8211 47.7435 70.7573C47.7435 71.6934 47.3718 72.5912 46.71 73.2534L42.3225 77.6675C37.6825 82.3046 31.3904 84.9085 24.8306 84.9064C18.2707 84.9043 11.9803 82.2964 7.34323 77.6564C2.70616 73.0164 0.102241 66.7244 0.10431 60.1645C0.10638 53.6047 2.71427 47.3143 7.35426 42.6772L18.001 32.0305C22.4578 27.5701 28.4507 24.9815 34.7533 24.7944C41.056 24.6074 47.1919 26.8359 51.9054 31.0241C52.2532 31.3325 52.5368 31.7063 52.7402 32.1243C52.9435 32.5423 53.0625 32.9963 53.0903 33.4603C53.1182 33.9243 53.0544 34.3892 52.9026 34.8285C52.7508 35.2679 52.5139 35.673 52.2056 36.0208C51.8972 36.3686 51.5233 36.6523 51.1053 36.8556C50.6873 37.0589 50.2333 37.1779 49.7694 37.2057C49.3054 37.2336 48.8404 37.1698 48.4011 37.018C47.9618 36.8662 47.5566 36.6293 47.2088 36.321C43.8423 33.3313 39.4608 31.7408 34.9604 31.8745C30.4601 32.0082 26.1808 33.8562 22.9977 37.0404L12.351 47.6739C9.03912 50.9858 7.17854 55.4776 7.17854 60.1613C7.17854 64.845 9.03912 69.3368 12.351 72.6487C15.6628 75.9605 20.1547 77.8211 24.8384 77.8211C29.522 77.8211 34.0139 75.9605 37.3257 72.6487L41.7133 68.2611C42.0413 67.9328 42.4307 67.6723 42.8594 67.4946C43.2881 67.3169 43.7476 67.2254 44.2117 67.2254C44.6758 67.2254 45.1353 67.3169 45.5639 67.4946C45.9926 67.6723 46.3821 67.9328 46.71 68.2611ZM77.6438 7.34705C73.0031 2.71678 66.7152 0.116394 60.1597 0.116394C53.6041 0.116394 47.3163 2.71678 42.6756 7.34705L38.288 11.739C37.626 12.4016 37.2543 13.3001 37.2547 14.2368C37.2551 15.1734 37.6276 16.0715 38.2902 16.7336C38.9528 17.3956 39.8513 17.7673 40.7879 17.7668C41.7246 17.7664 42.6227 17.394 43.2847 16.7313L47.6723 12.3438C50.9842 9.03191 55.476 7.17133 60.1597 7.17133C64.8434 7.17133 69.3352 9.03191 72.6471 12.3438C75.9589 15.6556 77.8195 20.1475 77.8195 24.8312C77.8195 29.5148 75.9589 34.0067 72.6471 37.3185L62.0004 47.9741C58.8156 51.1565 54.5354 53.002 50.035 53.1333C45.5346 53.2646 41.1541 51.6717 37.7892 48.6803C37.0868 48.0575 36.1658 47.7393 35.2287 47.7956C34.2916 47.8518 33.4153 48.2781 32.7925 48.9805C32.1697 49.6829 31.8514 50.6039 31.9077 51.541C31.964 52.4781 32.3903 53.3544 33.0927 53.9772C37.8051 58.1665 43.9403 60.3966 50.243 60.2112C56.5456 60.0257 62.5391 57.4388 66.9971 52.9796L77.6438 42.3329C82.2768 37.6919 84.8789 31.4021 84.8789 24.8444C84.8789 18.2867 82.2768 11.9969 77.6438 7.35588V7.34705Z"
                        fill="black"
                      />
                    </svg>
                    <p className="text-base text-black">Share Tracking Link</p>
                  </div>
                </button>

                <PDFDownloadButton
                  onClick={downloadPDF}
                  loading={loadingPdf}
                  label="Delivery Note"
                  disabled={
                    !formData.name ||
                    !formData.email ||
                    errors.name ||
                    errors.email
                  }
                />
                <PDFDownloadButton
                  onClick={downloadQuote}
                  loading={pdfLoading}
                  label="Quote"
                  disabled={
                    !formData.name ||
                    !formData.email ||
                    errors.name ||
                    errors.email
                  }
                />

                {/* <button onClick={downloadPDF} className="px-10 py-2 border rounded-lg border-[#9C9C9C] ">
                  {loadingPdf ? "Downloading..." : "Generated pdf"}
                </button> */}
              </div>

              {formData.document1 && (
                <div className="relative ">
                  <a
                    href={formData.document1.url}
                    target="_blank"
                    rel="noreferrer"
                    className="px-10 py-4 w-full"
                  >
                    {formData.document1.name}
                  </a>
                  <TiDelete
                    onClick={() => handleDeleteDoc(formData.id)}
                    className="absolute left-8 top-[-1rem] text-red-500 text-2xl "
                  />
                </div>
              )}
              {formData.documents && formData.documents.length > 0 && (
                <UploadedFiles files={formData.documents} onDelete={handleDeleteFile} />
              )}

              <div
                {...getRootProps()}
                className="mx-[30px] mb-4 cursor-pointer active:opacity-70 font-semibold flex flex-col justify-center items-center border-2 h-auto min-h-[92px] mt-8 border-dashed border-[#053F924A] p-4"
              >
                <input {...getInputProps()} />
                <p className="text-[10px] md:text-[15px] text-black text-center">
                  Supporting Documents (E.G. Commercial Invoice, Packing List, Datasheets)
                  <br />
                  Drag Excel, PDF or CSV files here to upload
                </p>
                {fileRejections.length > 0 && (
                  <p className="text-red-500 text-sm mt-2">
                    Some files were rejected. Only Excel, PDF, and CSV files are allowed.
                  </p>
                )}
              </div>

              <CustomButton
                label="Update Change "
                onClick={handleUpdateData}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default CreateShipment;
